import styled from 'styled-components';
import BellIcon from './BellIcon';

export const TileSubtitle = styled.div`
  color: #757989;
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 12px;
  white-space: pre-line;
`;

export const FlexContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;

  background: #fff;
  box-shadow: 1px 1.7px 2.9px rgba(25, 41, 61, 0.18);
  height: 100%;
  padding: 24px;

  @media (min-width: 768px) {
    padding: 24px 35px;
  }
`;

export const FlexPanel = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  div {
    text-align: left;
  }
  @media (min-width: 768px) {
    flex-direction: column;

    div {
      text-align: center;
    }
  }
`;

export const TextAndIconPanel = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;

  @media (min-width: 768px) {
    flex-direction: column;
    text-align: center;
    justify-content: center;
  }
`;

export const FullWidthFlexPanel = styled(FlexPanel)`
  width: 100%;
`;

export const CustomIcon = styled(BellIcon)`
  margin-bottom: 12px;
  margin-right: 14px;
  min-width: 54px;

  @media (min-width: 768px) {
    width: 100%;
  }
`;

export const TileTitle = styled.h4`
  line-height: 20px;
  text-transform: uppercase;
  font-size: 16px;
  font-weight: bold;

  @media (min-width: 768px) {
    font-size: 26px;
    line-height: 28px;
    margin-bottom: 12px;
    white-space: pre-line;
  }
`;
